module.exports = __webpack_public_path__ + "static/media/technical_mobile.52cc99da.jpg";